import React from "react";

const Footer = () => {
  return <div className="footer col-9">&copy; Jūratė Sveikauskė 2022</div>;
};

export default Footer;
